<template>
  <div>
    <UpNavSkeletonLoader v-if="!isAppReady" />
    <NuxtLayout v-if="isMounted" name="up-layout">
      <NuxtPage />
    </NuxtLayout>
    <CookieConsentContainer v-if="isMounted" />
  </div>
</template>

<script setup lang="ts">
import UpNavSkeletonLoader from "~/components/loaders/UpNavSkeletonLoader.vue";
import CookieConsentContainer from "~/components/shared/CookieConsent/CookieConsentContainer.vue";
import faviconUrl from "~/assets/images/favicon.ico";

useHead({
  bodyAttrs: { class: "font-sans" },
  link: [{ rel: "icon", type: "image/x-icon", href: faviconUrl }],
});

const nuxtApp = useNuxtApp();
const isMounted = useMounted();

const isAppReady = useState<boolean>("layoutReady", () => false);

nuxtApp.hook("page:loading:end", () => {
  isAppReady.value = true;
});
</script>
